type Valid<Reason extends string> = {_: 'valid'; reason: Reason};
type Invalid<Reason extends string> = {_: 'invalid'; reason: Reason};

/**
 * DO NOT USE THIS IN PRODUCTION CODE. FOR TESTING TYPES ONLY
 *
 * @deprecated DO NOT USE IN PRODUCTION CODE (Not actual deprecated)
 * @param _
 */
export function expectValidTypeCheck(_: Valid<any>): void {}

/**
 * DO NOT USE THIS IN PRODUCTION CODE. FOR TESTING TYPES ONLY
 *
 * @deprecated DO NOT USE IN PRODUCTION CODE (Not actual deprecated)
 * @param _
 */
export function expectInvalidTypeCheck(_: Invalid<any>): void {}

/**
 * DO NOT USE THIS IN PRODUCTION CODE. FOR TESTING TYPES ONLY
 *
 * @deprecated DO NOT USE IN PRODUCTION CODE (Not actual deprecated)
 * @param _
 */
export function expectType<A>(_?: A) {
  return {
    toMatch<B>(): Required<A> extends Required<B>
      ? Required<B> extends Required<A>
        ? Valid<'A & B extend each other'>
        : Invalid<'B does not extend A'>
      : Invalid<'A does not extend B'> {
      return undefined as any;
    },
    toNotMatch<B>(): A extends B
      ? B extends A
        ? Invalid<'A and B match'>
        : Valid<'B does not extend A'>
      : Valid<'A does not extend B'> {
      return undefined as any;
    },
    toExtend<B>(): A extends B ? Valid<'A extends B'> : Invalid<'A does not extend B'> {
      return undefined as any;
    },
    toBeExtendedBy<B>(): B extends A ? Valid<'B extends A'> : Invalid<'B does not extend A'> {
      return undefined as any;
    },
  };
}

// These test the above. Minimal code should be generated from this...

interface TestInterface {
  name: string;
}

const matchingType = {name: 'Jacob Gardner'};

expectValidTypeCheck(expectType(matchingType).toMatch<TestInterface>());
expectInvalidTypeCheck(expectType(matchingType).toNotMatch<TestInterface>());
expectValidTypeCheck(expectType(matchingType).toExtend<TestInterface>());
expectValidTypeCheck(expectType(matchingType).toBeExtendedBy<TestInterface>());

// @ts-expect-error
expectValidTypeCheck(expectType(matchingType).toNotMatch<TestInterface>());
// @ts-expect-error
expectInvalidTypeCheck(expectType(matchingType).toMatch<TestInterface>());

const subsetType = {};

expectInvalidTypeCheck(expectType(subsetType).toMatch<TestInterface>());
expectValidTypeCheck(expectType(subsetType).toNotMatch<TestInterface>());
expectInvalidTypeCheck(expectType(subsetType).toExtend<TestInterface>());
expectValidTypeCheck(expectType(subsetType).toBeExtendedBy<TestInterface>());

const superSetType = {name: 'Jake Gardner', phone: '000-000-0000'};

expectInvalidTypeCheck(expectType(superSetType).toMatch<TestInterface>());
expectValidTypeCheck(expectType(superSetType).toNotMatch<TestInterface>());
expectValidTypeCheck(expectType(superSetType).toExtend<TestInterface>());
expectInvalidTypeCheck(expectType(superSetType).toBeExtendedBy<TestInterface>());
